import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface WelcomeInfoState {
    login: string,
    preferredName: string,
    passwordEventId: string,
    ingressPoint: string
}

export const initialState: WelcomeInfoState = {
    login: '',
    preferredName: '',
    passwordEventId: '',
    ingressPoint: ''
}

const welcomeInfoSlice = createSlice({
    name: 'welcome-info',
    initialState,
    reducers: {
        setLogin: (state: WelcomeInfoState, action: PayloadAction<string>) => {
            state.login = action.payload;
        },
        setPreferredName: (state: WelcomeInfoState, action: PayloadAction<string>) => {
            state.preferredName = action.payload;
        },
        setPasswordEventId: (state: WelcomeInfoState, action: PayloadAction<string>) => {
            state.passwordEventId = action.payload;
        },
        setIngressPoint: (state: WelcomeInfoState, action: PayloadAction<string>) => {
            state.ingressPoint = action.payload
        }
    }
});

export const { setLogin, setPreferredName, setPasswordEventId, setIngressPoint } = welcomeInfoSlice.actions;

export default welcomeInfoSlice.reducer;
